import { connect } from "react-redux";
// 系统菜单
import SysMenu from "../components/SysMenu";

const mapState = state => ({
  // 筛选项数据
  sysMenu: state.sysInfo.sysMenu,
  sysMenuStatus: state.globalStatus.sysMenuMg
});

const mapDispatch = dispatch => {
  return {
    // 获取筛选项列表
    getSysMenu: dispatch.sysInfo.getSysMenu,
    updateSysMenuStatus: dispatch.globalStatus.updateSysMenuStatus
  };
};

export default connect(
  mapState,
  mapDispatch
)(SysMenu);
